var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "39px",
    viewBox: "0 0 46 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4954DA97-6E9D-4BFC-A029-C9C6D2A88C0D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 122018,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(-147.000000, -566.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.111867,601.239354 C191.231691,599.741415 173.457702,569.803374 171.937122,567.247892 C170.938072,565.57024 168.55755,565.597889 167.557488,567.247892 C166.442599,569.087484 148.578062,599.139573 147.336711,601.31588 C146.42669,602.9096 147.43181,605 149.502753,605 L189.933179,605 C191.813417,605 193.211581,603.108568 192.111867,601.239354 Z M169.75,601.75 C168.404012,601.75 167.3125,600.658975 167.3125,599.3125 C167.3125,597.966025 168.404012,596.875 169.75,596.875 C171.096475,596.875 172.1875,597.966025 172.1875,599.3125 C172.1875,600.658975 171.096475,601.75 169.75,601.75 Z M171.375,593.710526 C171.375,594.736842 170.833333,595.25 169.75,595.25 C168.666667,595.25 168.125,594.736842 168.125,593.710526 L166.5,578.828947 C166.5,577.289474 167.583333,575.75 169.75,575.75 C171.916667,575.75 173,577.289474 173,578.828947 L171.375,593.710526 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWhite);
export default __webpack_public_path__ + "static/media/alert-white.dfa35dfed28260fe36ce8299622a63b2.svg";
export { ForwardRef as ReactComponent };